import { render, staticRenderFns } from "./CreateChickenleg.vue?vue&type=template&id=89af222c"
import script from "./CreateChickenleg.vue?vue&type=script&lang=js"
export * from "./CreateChickenleg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports